export default {
	DOC_EDITOR: {
		text: 'Documento',
		icon: 'article',
		text_sended: 'Publicado Área Pública',
		icon_sended: 'mdi-text-box-check',
		value: 'DOC_EDITOR',
	},
	ANEXO: {
		text: 'Anexo',
		icon: 'attach_file',
		text_sended: 'Publicado Área Pública',
		icon_sended: 'mdi-paperclip-check',
		value: 'ANEXO',
	},
}
